import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../../Global/Layout';
import DataTable from '../../Global/DataTable';
import ExportExcel from '../../Global/ExportToExcel';
import { showError, showSuccess, showConfirm } from '../../../utils/sweetAlertConfig';
import { API_CONFIG, ICON_ACTION, LOTTO_TYPE, dateStampToDateDB, generatePromptPayQRCodeURL } from '../../../contexts/constants';
import { formatTHB } from '../../../utils/numberFormat';
import DatePicker from 'react-datepicker';
import { th } from 'date-fns/locale';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDateTimeTable } from '../../../utils/dateFormatter';
import { LottoBallsWinning } from '../../../utils/LottoBalls';
import Select from 'react-select';

const ReportWinning = ({ onLogout, userRole, exportExcel, menuName }) => {
  const [loading, setLoading] = useState(false);
  const [winningData, setWinningData] = useState([]);
  const [columnsExcelData, setColumnsExcelData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [showSearchForm, setShowSearchForm] = useState(false);
  const [awardResultsList, setAwardResultsList] = useState([]);
  const [loadSummary, setLoadSummary] = useState(false);
const [historySummary, setHistorySummary] = useState({
	pb: {
		id: 0,
		date: '',
	},
	mg: {
		id: 0,
		date: '',
	},
	total: 0
	});
  const [filters, setFilters] = useState({
    name: '',
    types: [], // Changed to array for multiple selection
    statuses: [], // Changed to array for multiple selection
    awardIds: [] // New: for award results selection
  });
  const [appliedFilters, setAppliedFilters] = useState({
    name: '',
    types: [],
    statuses: [],
    awardIds: []
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [appliedStartDate, setAppliedStartDate] = useState(null);
  const [appliedEndDate, setAppliedEndDate] = useState(null);

  // States for payment modal
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedOrderBall, setSelectedOrderBall] = useState(null);
  const [paymentSlipFile, setPaymentSlipFile] = useState(null);
  const [paymentSlipPreview, setPaymentSlipPreview] = useState(null);
  const [showViewSlipModal, setShowViewSlipModal] = useState(false);
  const [viewSlipUrl, setViewSlipUrl] = useState(null);

  // const formatTHB = (amount) => new Intl.NumberFormat('th-TH', { maximumFractionDigits: 0 }).format(amount);


	useEffect(() => {
		fetchWinnerList();
		fetchDataSummary();
		fetchAwardResultsList();
	}, [currentPage, pageSize, appliedFilters, appliedStartDate, appliedEndDate]);

  	if (!['sysadmin', 'owner', 'admin', 'agent'].includes(userRole)) {
		window.location.href = '/forbidden';
		return null;
	}

	const fetchAwardResultsList = async () => {
		try {
		const response = await axios.get(`${API_CONFIG.BASE_URL}/report/award-results`, {
			headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
		});

		if (response.data && Array.isArray(response.data.data)) {
			const options = [
				{ value: '', label: 'ทั้งหมด' },
				...response.data.data.map(item => ({
					value: item.id.toString(),
					label: item.label + ' (' + (item.lot_type === 1 ? LOTTO_TYPE.powerball : LOTTO_TYPE.megamillions) + ')'
				}))
			];
			setAwardResultsList(options);
		}
		} catch (error) {
		console.error('Error fetching award results:', error);
		}
	};

	const fetchWinnerList = async () => {
		try {
		setLoading(true);

		// Build query parameters
		const params = new URLSearchParams();
		params.append('page', currentPage);
		params.append('pageSize', pageSize);

		// Add filters
		if (appliedFilters.name) params.append('member_name', appliedFilters.name);

		// Add lottery type filters
		if (appliedFilters.types.includes('powerball')) params.append('type_powerball', 'true');
		if (appliedFilters.types.includes('megamillions')) params.append('type_megamillions', 'true');

		// Add status filters
		if (appliedFilters.statuses.includes('จ่ายแล้ว')) params.append('status_paid', 'true');
		if (appliedFilters.statuses.includes('รอดำเนินการ')) params.append('status_pending', 'true');

		// Add period filters
		if (appliedFilters.awardIds.length > 0) {
			appliedFilters.awardIds.forEach(awardId => params.append('period', awardId));
		}

		// Add daappliedStartDatete range
		if (startDate) params.append('startDate', dateStampToDateDB(appliedStartDate));
		if (appliedEndDate) params.append('endDate', dateStampToDateDB(appliedEndDate));

		const response = await axios.get(`${API_CONFIG.BASE_URL}/report/winning?${params.toString()}`, {
			headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
		});

		if (response.data.success && Array.isArray(response.data.data)) {
			console.log("API Response Data:", response.data.data);
			setWinningData(response.data.data);
			setTotalItems(response.data.total || 0);
			setTotalPages(response.data.totalPages || 1);

			const formattedData = response.data.data.map(r => {
			const prizeLabels = {
				'5_1': 'Match 5 + Special',
				'5_0': 'Match 5',
				'4_1': 'Match 4 + Special',
				'4_0': 'Match 4',
				'3_1': 'Match 3 + Special',
				'3_0': 'Match 3',
				'2_1': 'Match 2 + Special',
				'1_1': 'Match 1 + Special',
				'0_1': 'Match 0 + Special'
			};

			return {
				drawDate: formatDateTimeTable(r.draw_date) || '',
				userName: `${r.user_name || ''}`,
				type: LOTTO_TYPE[r.type] || r.type || '',
				grayBalls: Array.isArray(r.gray_balls)
				? r.gray_balls.join(', ')
				: '',
				redBall: r.red_ball || '',
				prizeType: prizeLabels[r.prize_type] || '',
				amount: r.amount || 0,
				status: r.status || ''
			};
			});
			setColumnsExcelData(formattedData);

		} else {
			console.error('Invalid results data format');
			setWinningData([]);
		}
		} catch (error) {
		console.error('Error fetching results:', error);

		// แสดง error message จาก API
		let errorMessage = 'ไม่สามารถโหลดข้อมูลผลรางวัลได้';

		if (error.response) {
			errorMessage = error.response.data?.message || `เกิดข้อผิดพลาด (${error.response.status})`;

			if (error.response.status === 401 || error.response.status === 403) {
			errorMessage = error.response.data?.message || 'กรุณาเข้าสู่ระบบใหม่';
			showError('เซสชันหมดอายุ', errorMessage);
			setTimeout(() => {
				localStorage.removeItem('token');
				onLogout();
			}, 1500);
			return;
			}
		} else if (error.request) {
			errorMessage = 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้';
		}

		showError('เกิดข้อผิดพลาด', errorMessage);
		setWinningData([]);
		}finally {
		setLoading(false);
		}
	};

	const fetchDataSummary = async () => {
		if(userRole !== 'customer' && loadSummary === false){
			try {
				const params = new URLSearchParams();
				const response = await axios.get(`${API_CONFIG.BASE_URL}/report/order-summary-prize?${params.toString()}`, {
					headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
				});

				if(response.data.pb){
					filters.awardIds.push(response.data.pb.award_results_id.toString());
					appliedFilters.awardIds.push(response.data.pb.award_results_id.toString());
				}
				if(response.data.mg){
					filters.awardIds.push(response.data.mg.award_results_id.toString());
					appliedFilters.awardIds.push(response.data.mg.award_results_id.toString());
				}

				setAppliedFilters({ ...appliedFilters });
				setHistorySummary({
					pb: {
						id: response.data.pb.award_results_id,
						date: response.data.pb.date,
					},
					mg: {
						id: response.data.mg.award_results_id,
						date: response.data.mg.date,
					},
					total: response.data.total || 0
				});
				setLoadSummary(true);
			} catch (error) {
				console.error('Error fetching results:', error);
			}
		}
	};

  const handlePaymentClick = (orderBall) => {
    setSelectedOrderBall(orderBall);
    setPaymentSlipFile(null);
    setPaymentSlipPreview(null);
    setShowPaymentModal(true);
  };

  const handlePaymentFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        showError('ไฟล์ใหญ่เกินไป', 'กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 5MB');
        return;
      }
      setPaymentSlipFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPaymentSlipPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemovePaymentSlip = () => {
    setPaymentSlipFile(null);
    setPaymentSlipPreview(null);
  };

  const handleUploadPaymentSlip = async () => {
    if (!paymentSlipFile) {
      showError('กรุณาเลือกไฟล์', 'กรุณาเลือกไฟล์หลักฐานการจ่ายก่อนทำการอัพโหลด');
      return;
    }

    const result = await showConfirm({
      title: 'ยืนยันการอัพโหลดหลักฐาน',
      html: 'คุณต้องการอัพโหลดหลักฐานการจ่ายรางวัลใช่หรือไม่?'
    });

    if (result.isConfirmed) {
      try {
        const formData = new FormData();
        formData.append('orderBallId', selectedOrderBall.id);
        formData.append('slip', paymentSlipFile);

        const response = await fetch(`${API_CONFIG.BASE_URL}/report/prize-payment`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: formData
        });

        const resultData = await response.json();

        if (response.ok && resultData.success) {
          setShowPaymentModal(false);
          setPaymentSlipFile(null);
          setPaymentSlipPreview(null);
          setSelectedOrderBall(null);
          showSuccess('อัพโหลดหลักฐานสำเร็จ', 'บันทึกสถานะการจ่ายรางวัลเรียบร้อยแล้ว');
          fetchWinnerList();
        } else {
          showError('เกิดข้อผิดพลาด', resultData.message || 'ไม่สามารถอัพโหลดหลักฐานได้');
        }
      } catch (error) {
        console.error('Error uploading payment slip:', error);
        showError('เกิดข้อผิดพลาด', 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้');
      }
    }
  };

  const handleViewPaymentSlipClick = async (orderBallId) => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/report/prize-payment-slip/${orderBallId}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.data.success && response.data.slipUrl) {
        setViewSlipUrl(response.data.slipUrl);
        setShowViewSlipModal(true);
      } else {
        showError('ไม่พบหลักฐาน', 'ไม่พบไฟล์หลักฐานการจ่ายรางวัล');
      }
    } catch (error) {
      console.error('Error fetching payment slip:', error);
      showError('เกิดข้อผิดพลาด', 'ไม่สามารถโหลดหลักฐานการจ่ายรางวัลได้');
    }
  };


  const columns = [
    {
      key: 'userName',
      header: 'ชื่อลูกค้า',
      className: 'min-w-60',
      render: (row) => (
		<div>
        	<div className="text-left">{row.user_name}</div>
        	<div className="text-sm">ซื้อเมื่อ: {formatDateTimeTable(row.draw_date)}</div>
		</div>
      )
    },
    {
      key: 'lotteryType',
      header: 'ประเภท',
      render: (row) => (
        <div className="text-center">
          <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${
          row.type === 'powerball'
            ? 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300'
            : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300'
          }`}>
          {LOTTO_TYPE[row.type]}
          </span>
        </div>
      )
    },
    {
      key: 'betNumber',
      header: 'เลขที่สั่งซื้อ',
      className: 'min-w-60',
      render: (row) => (
        <LottoBallsWinning
          grayBalls={row.gray_balls}
          specialBall={row.red_ball}
          winningGrayBalls={row.winning_gray_balls}
          winningSpecialBall={row.winning_red_ball}
          type={row.type}
        />
      )
    },
    {
      key: 'prizeType',
      header: 'ประเภทรางวัล',
      render: (row) => {
        const prizeLabels = {
          '5_1': 'Match 5 + Special',
          '5_0': 'Match 5',
          '4_1': 'Match 4 + Special',
          '4_0': 'Match 4',
          '3_1': 'Match 3 + Special',
          '3_0': 'Match 3',
          '2_1': 'Match 2 + Special',
          '1_1': 'Match 1 + Special',
          '0_1': 'Match 0 + Special'
        };
        return (
          <div className="text-center text-sm">
            {prizeLabels[row.prize_type] || '-'}
          </div>
        );
      }
    },
    {
      key: 'prizeName',
      header: 'รางวัลที่ได้รับ',
      render: (row) => (
        <div className="text-center">{formatTHB(row.amount)}</div>
      )
    },
    {
      key: 'status',
      header: 'สถานะ',
      render: (row) => (
        <div className={`text-center ${row.status === 'จ่ายแล้ว' ? 'text-green-500' : 'text-yellow-500'}`}>{row.status}</div>
      )
    },
  ];

  // Add 'จัดการ' column for admin, owner, agent roles
  if (exportExcel !== 'true') {
    columns.push({
      key: 'actions',
      header: 'จัดการ',
      className: 'min-w-32',
      render: (row) => (
        <div className="text-center flex justify-center gap-2">
          {row.status === 'รอดำเนินการ' && (
            <button
              onClick={() => handlePaymentClick(row)}
              className="px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-xs font-medium transition-colors"
              title="อัพโหลดหลักฐานการจ่าย"
            >
              จ่ายเงิน
            </button>
          )}
          {row.status === 'จ่ายแล้ว' && row.file_id && (
            <button
              onClick={() => handleViewPaymentSlipClick(row.id)}
              className="px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-xs font-medium transition-colors"
              title="ดูหลักฐานการจ่าย"
            >
              ดูหลักฐาน
            </button>
          )}
        </div>
      )
    });
  }

  const gotoPage = (p) => {
    if (p < 1 || p > totalPages) return;
    setCurrentPage(p);
  };

  const headersExcel = [
    { key: 'drawDate', label: 'วันที่' },
    { key: 'userName', label: 'ชื่อลูกค้า' },
    { key: 'type', label: 'ประเภท' },
    { key: 'grayBalls', label: 'เลขปกติ' },
    { key: 'redBall', label: 'เลขพิเศษ' },
    { key: 'prizeType', label: 'ประเภทรางวัล' },
    { key: 'amount', label: 'รางวัล (บาท)' },
    { key: 'status', label: 'สถานะ' }
  ];

  const toggleSearchForm = () => {
		setShowSearchForm(!showSearchForm);
	};

  const handleSearch = () => {
    setAppliedFilters({ ...filters });
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
    setCurrentPage(1);
    // fetchWinnerList will be called by useEffect when currentPage changes
  };

  const handleClearSearch = () => {
    setFilters({
      name: '',
      types: [],
      statuses: [],
      awardIds: []
    });
    setAppliedFilters({
      name: '',
      types: [],
      statuses: [],
      awardIds: []
    });
    setStartDate(null);
    setEndDate(null);
    setAppliedStartDate(null);
    setAppliedEndDate(null);
    setCurrentPage(1);
  };

  const SearchForm = () => (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow mb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {/* เลือกงวด (Select Multiple) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            งวดวันที่
          </label>
          <Select
            isMulti
            value={awardResultsList.filter(award => filters.awardIds.includes(award.value))}
            onChange={(selectedOptions) => {
              setFilters(prev => ({
                ...prev,
                awardIds: selectedOptions ? selectedOptions.map(opt => opt.value) : []
              }));
            }}
            options={awardResultsList}
            placeholder="เลือกงวด..."
            className="basic-multi-select"
            classNamePrefix="select"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                minHeight: '42px',
                borderColor: '#d1d5db',
                backgroundColor: 'var(--tw-bg-opacity)',
              }),
              menu: (base) => ({
                ...base,
                zIndex: 100,
              })
            }}
          />
        </div>

        {/* ค้นหาตามชื่อ */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            ชื่อลูกค้า
          </label>
          <input
            type="text"
            value={filters.name}
            onChange={(e) => setFilters(prev => ({ ...prev, name: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="ค้นหาตามชื่อ"
          />
        </div>

        {/* วันที่เริ่มต้น */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            วันที่เริ่มต้น
          </label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            dateFormat="dd/MM/yyyy"
            locale={th}
            placeholderText="เลือกวันที่เริ่มต้น"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            isClearable
          />
        </div>

        {/* วันที่สิ้นสุด */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            วันที่สิ้นสุด
          </label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            dateFormat="dd/MM/yyyy"
            locale={th}
            placeholderText="เลือกวันที่สิ้นสุด"
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            isClearable
          />
        </div>

        {/* ประเภท (Checkbox) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            ประเภท
          </label>
          <div className="flex gap-4">
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={filters.types.includes('powerball')}
                onChange={(e) => {
                  if (e.target.checked) {
                    setFilters(prev => ({ ...prev, types: [...prev.types, 'powerball'] }));
                  } else {
                    setFilters(prev => ({ ...prev, types: prev.types.filter(t => t !== 'powerball') }));
                  }
                }}
                className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              />
              <span className="text-gray-700 dark:text-gray-300">Powerball</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={filters.types.includes('megamillions')}
                onChange={(e) => {
                  if (e.target.checked) {
                    setFilters(prev => ({ ...prev, types: [...prev.types, 'megamillions'] }));
                  } else {
                    setFilters(prev => ({ ...prev, types: prev.types.filter(t => t !== 'megamillions') }));
                  }
                }}
                className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              />
              <span className="text-gray-700 dark:text-gray-300">Mega Millions</span>
            </label>
          </div>
        </div>

        {/* สถานะการจ่ายรางวัล (Checkbox) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            สถานะการจ่ายรางวัล
          </label>
          <div className="flex gap-4">
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={filters.statuses.includes('จ่ายแล้ว')}
                onChange={(e) => {
                  if (e.target.checked) {
                    setFilters(prev => ({ ...prev, statuses: [...prev.statuses, 'จ่ายแล้ว'] }));
                  } else {
                    setFilters(prev => ({ ...prev, statuses: prev.statuses.filter(s => s !== 'จ่ายแล้ว') }));
                  }
                }}
                className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              />
              <span className="text-gray-700 dark:text-gray-300">จ่ายแล้ว</span>
            </label>
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={filters.statuses.includes('รอดำเนินการ')}
                onChange={(e) => {
                  if (e.target.checked) {
                    setFilters(prev => ({ ...prev, statuses: [...prev.statuses, 'รอดำเนินการ'] }));
                  } else {
                    setFilters(prev => ({ ...prev, statuses: prev.statuses.filter(s => s !== 'รอดำเนินการ') }));
                  }
                }}
                className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              />
              <span className="text-gray-700 dark:text-gray-300">รอดำเนินการ</span>
            </label>
          </div>
        </div>

      </div>
      <div className="flex justify-end gap-2 mt-4">
        <button
          onClick={handleSearch}
          className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md font-medium transition-colors flex items-center gap-2"
        >
          {ICON_ACTION.SEARCH}
          ค้นหา
        </button>
        <button
          onClick={handleClearSearch}
          className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-md font-medium transition-colors flex items-center gap-2"
        >
          {ICON_ACTION.CLEAR}
          ล้าง
        </button>
      </div>
    </div>
  );

  const PaymentUploadModal = () => (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-2xl my-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">
            อัพโหลดหลักฐานการจ่ายรางวัล
          </h3>
          <button
            onClick={() => {
              setShowPaymentModal(false);
              setPaymentSlipFile(null);
              setPaymentSlipPreview(null);
              setSelectedOrderBall(null);
            }}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            aria-label="ปิด"
          >
            <svg className="w-6 h-6 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          {/* Prize Information */}
          {selectedOrderBall && (
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border-2 border-green-300 dark:border-green-700 rounded-xl p-4">
              <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-2">
                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                ข้อมูลรางวัล
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <p className="text-xs text-gray-600 dark:text-gray-400">ชื่อลูกค้า</p>
                  <p className="text-base font-bold text-gray-900 dark:text-white">{selectedOrderBall.user_name || '-'}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-600 dark:text-gray-400">ประเภท</p>
                  <p className="text-base font-semibold text-gray-900 dark:text-white">{LOTTO_TYPE[selectedOrderBall.type] || '-'}</p>
                </div>
                <div>
                  <p className="text-xs text-gray-600 dark:text-gray-400">จำนวนเงินรางวัล</p>
                  <p className="text-xl font-bold text-green-600 dark:text-green-400">{formatTHB(selectedOrderBall.amount || 0)} บาท</p>
                </div>
              </div>
            </div>
          )}

          {/* Customer Bank Account & PromptPay */}
          {selectedOrderBall && (
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-5">
              <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4 flex items-center gap-2">
                <svg className="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                ช่องทางรับเงินของลูกค้า
              </h4>

              {selectedOrderBall.prompt_pay && (
                <div className="mb-4">
                  <div className="flex flex-col items-center bg-white dark:bg-gray-700 rounded-lg p-4 border border-gray-200 dark:border-gray-600">
                    <p className="text-base font-semibold text-gray-900 dark:text-white mb-2">พร้อมเพย์</p>
                    <div className="bg-white rounded-lg p-2">
                      <img
                        src={generatePromptPayQRCodeURL(selectedOrderBall.prompt_pay, selectedOrderBall.amount)}
                        alt="PromptPay QR Code"
                        className="w-40 h-40"
                        onError={(e) => {
                          e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23f3f4f6'/%3E%3Ctext x='100' y='100' text-anchor='middle' fill='%236b7280' font-size='14'%3EQR Code%3C/text%3E%3C/svg%3E";
                        }}
                      />
                    </div>
                    {selectedOrderBall.prompt_pay_name && (
                      <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">ชื่อบัญชี: {selectedOrderBall.prompt_pay_name}</p>
                    )}
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">เลขพร้อมเพย์: {selectedOrderBall.prompt_pay}</p>
                  </div>
                </div>
              )}

              {selectedOrderBall.bank_account && (
                <div className="bg-white dark:bg-gray-700 rounded-lg p-4 border border-gray-200 dark:border-gray-600">
                  <p className="text-base font-semibold text-gray-900 dark:text-white mb-2">บัญชีธนาคาร</p>
                  <div className="space-y-1 text-sm text-gray-600 dark:text-gray-400">
                    {selectedOrderBall.bank_name && (
                      <p><span className="font-medium">ธนาคาร:</span> {selectedOrderBall.bank_name}</p>
                    )}
                    <p><span className="font-medium">เลขบัญชี:</span> {selectedOrderBall.bank_account}</p>
                    {selectedOrderBall.bank_account_name && (
                      <p><span className="font-medium">ชื่อบัญชี:</span> {selectedOrderBall.bank_account_name}</p>
                    )}
                  </div>
                </div>
              )}

              {!selectedOrderBall.prompt_pay && !selectedOrderBall.bank_account && (
                <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-2">ลูกค้ายังไม่ได้กรอกข้อมูลบัญชีรับเงิน</p>
              )}
            </div>
          )}

          {/* File Upload Section */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              อัพโหลดหลักฐานการจ่ายเงิน (รูปภาพ)
            </label>
            {!paymentSlipPreview ? (
              <div className="flex items-center justify-center w-full">
                <label className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg className="w-10 h-10 mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span className="font-semibold">คลิกเพื่ออัพโหลด</span> หรือลากไฟล์มาวาง
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">PNG, JPG, GIF (สูงสุด 5MB)</p>
                  </div>
                  <input
                    type="file"
                    className="hidden"
                    accept="image/*"
                    onChange={handlePaymentFileChange}
                  />
                </label>
              </div>
            ) : (
              <div className="relative">
                <img
                  src={paymentSlipPreview}
                  alt="Preview"
                  className="w-full h-64 object-contain bg-gray-100 dark:bg-gray-700 rounded-lg"
                />
                <button
                  onClick={handleRemovePaymentSlip}
                  className="absolute top-2 right-2 p-2 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-lg transition-colors"
                  title="ลบรูป"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                <div className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                  <p className="truncate">{paymentSlipFile?.name}</p>
                  <p>{(paymentSlipFile?.size / 1024).toFixed(2)} KB</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
          <button
            onClick={() => {
              setShowPaymentModal(false);
              setPaymentSlipFile(null);
              setPaymentSlipPreview(null);
              setSelectedOrderBall(null);
            }}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors font-medium"
          >
            ยกเลิก
          </button>
          <button
            onClick={handleUploadPaymentSlip}
            disabled={!paymentSlipFile}
            className="px-4 py-2 bg-green-500 hover:bg-green-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors font-medium"
          >
            อัพโหลดและบันทึก
          </button>
        </div>
      </div>
    </div>
  );

  const ViewSlipModal = () => (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-3xl">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <h3 className="text-xl font-bold text-gray-900 dark:text-white">
            หลักฐานการจ่ายรางวัล
          </h3>
          <button
            onClick={() => {
              setShowViewSlipModal(false);
              setViewSlipUrl(null);
            }}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            aria-label="ปิด"
          >
            <svg className="w-6 h-6 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <img
            src={viewSlipUrl || '/slip-bank-empty.jpg'}
            alt="หลักฐานการจ่ายรางวัล"
            className="w-full h-auto max-h-[70vh] object-contain bg-gray-100 dark:bg-gray-700 rounded-lg"
          />
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end">
          <button
            onClick={() => {
              setShowViewSlipModal(false);
              setViewSlipUrl(null);
            }}
            className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg transition-colors font-medium"
          >
            ปิด
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <Layout title={menuName} onLogout={onLogout} userRole={userRole}>
      <div className="flex justify-end gap-3 mb-4">
        {/* Toggle Search */}
        <button
          onClick={toggleSearchForm}
          className={`flex items-center gap-2 px-4 py-2 text-white rounded-lg transition shadow-lg ${
            showSearchForm
            ? 'bg-red-500 hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700'
            : 'bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700'
          }`}
        >
          {showSearchForm ? ICON_ACTION.CLOSE : ICON_ACTION.SEARCH}
          <span className='hidden md:inline'>ค้นหา</span>
        </button>
        {/* Export CSV */}
		{ exportExcel === 'true' && (
			<ExportExcel
				data={columnsExcelData}
				headers={headersExcel}
				fileName={`ReportWining${new Date().toISOString().slice(0,19).replace(/[:T]/g, '-')}.xlsx`}
			/>
		)}
      </div>

      {/* แสดงข้อมูล filter */}
      <div className="mb-4">
		<p className={`text-sm mt-1 text-gray-500 dark:text-gray-400`}>
			{
				historySummary.pb.id && historySummary.mg.id ? (
					<>
						รายการผู้ถูกรางวัล {LOTTO_TYPE.powerball} ประจำงวดวันที่ {historySummary.pb.date || 'ทั้งหมด'} และ {LOTTO_TYPE.megamillions} ประจำงวดวันที่ {historySummary.mg.date || 'ทั้งหมด'} รวมจำนวน <span className="font-semibold text-gray-900 dark:text-white">{formatTHB(historySummary.total || 0)}</span> รายการ
					</>
				) : (
					historySummary.mg.id ? (
						<>
							รายการผู้ถูกรางวัล {LOTTO_TYPE.megamillions} ประจำงวดวันที่ {historySummary.mg.date || 'ทั้งหมด'} จำนวน <span className="font-semibold text-gray-900 dark:text-white">{formatTHB(historySummary.total || 0)}</span> รายการ
						</>
					) : (
						<>
							รายการผู้ถูกรางวัล {LOTTO_TYPE.powerball} ประจำงวดวันที่ {historySummary.pb.date || 'ทั้งหมด'} จำนวน <span className="font-semibold text-gray-900 dark:text-white">{formatTHB(historySummary.total || 0)}</span> รายการ
						</>
					)
				)
			}
		</p>
      </div>

      {showSearchForm && (
        <SearchForm />
      )}

      <DataTable
        columns={columns}
        data={winningData}
        loading={loading}
        page={currentPage}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChange={gotoPage}
        onPageSizeChange={(size) => { setPageSize(size); setCurrentPage(1); }}
        emptyMessage="ไม่มีข้อมูลผลรางวัล"
        showPagination={true}
      />

      {/* Modals */}
      {showPaymentModal && <PaymentUploadModal />}
      {showViewSlipModal && <ViewSlipModal />}
    </Layout>
  );

}

export default ReportWinning;
